import React, {useState, useEffect, useCallback, useRef} from 'react';
import {Link, useNavigate} from 'react-router-dom';
import styled from 'styled-components';

import DatabaseService from '../../services/DatabaseService';


import UsersNew from './UsersNew';
import Layout from '../layout/Layout';
// import Filters from './../layout/Filters';

import Container from '../../common/components/Container';
import Row from '../../common/components/Row';
import Col from '../../common/components/Col';
import Table from '../../common/components/Table';
import Loading from '../../common/components/Loading';
import Card from '../../common/components/Card';
import Button from '../../common/components/Button';
import Overlay from './../../common/components/Overlay';

const Header = styled.div.withConfig({displayName:'-Header'})`
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 40px;
  margin-bottom: 40px;
`;
const TableWrapper = styled.div.withConfig({displayName:'-TableWrapper'})`
  & table tr td{
    white-space: nowrap;
  }
  & table tr td:nth-child(2),
  & table tr td:nth-child(3){
    word-break: break-all;
    white-space: unset;
  }
  overflow-x: auto; 
`;
const TableActions = styled.div.withConfig({displayName:'-TableActions'})`
  display: flex;
  justify-content: flex-end;
  align-items: center;

  & > *{
    margin-left: 5px;
  }
`;
const NoResult = styled.div.withConfig({displayName:'-NoResult'})`
  text-align: center;
`;
const Title = styled.div.withConfig({displayName:'-Title'})`
  font-family: 'Roboto',cursive;
  font-size: 30px;
`;


const UsersList = ({layout}) => {
  let scrollRef = useRef(null);
  let navigate = useNavigate();
  const [list, setList] = useState(null);
  const [showModalNew, toggleModalNew] = useState(false);
  // const [page, setPage] = useState(0);


  const getList = useCallback(() => {
    if(scrollRef && scrollRef.current){
      scrollRef.current.scrollTo(0,0);
    }
    DatabaseService.listUtenti().then((response) => {
      setList(response);
    });

  }, []); //}, [page, filters]);



  useEffect(() => {
    getList();
  }, [getList]); //}, [getList, page]);

  const deleteItem = useCallback((item) => {
    setList(null);
    DatabaseService.deleteUtente(item.id).then((response) => {
      getList();
    });
  }, [getList]);

  const promoteItem = useCallback((item) => {
    setList(null);
    DatabaseService.promoteUtente(item.id).then((response) => {
      getList();
    });
  }, [getList]);

  const demoteItem = useCallback((item) => {
    setList(null);
    DatabaseService.demoteUtente(item.id).then((response) => {
      getList();
    });
  }, [getList]);

  return (
    <Layout layout={layout}>
      <div ref={scrollRef}>
        <Container>
          <Header>
            <Title><i className="fa-solid fa-users"></i> Utenti</Title>            
            <Button onClick={() => toggleModalNew(true)}>Nuovo</Button>
          </Header>

          <Row>
            <Col>
              <Card>
                <Row>
                  <Col widthmd="12">
                    {list !== null ?
                      list.length > 0 ?
                        <>
                          <TableWrapper>
                            <Table
                              columns={[
                                "Email",
                                "Nominativo",
                                "Società",
                                "Ruolo",
                                ""
                              ]}
                              values={
                                list.map(item => ({
                                  values: [
                                    item.email,  
                                    item.family_name + " " + item.given_name,   
                                    item.address,
                                    item.groups.join(", ").includes("CesiAdmin") ? "Admin" : "User", 
                                    <TableActions onClick={(e) => {e.preventDefault(); e.stopPropagation()}}>
                                      {item.groups.join(", ").includes("CesiAdmin") ? 
                                        <Button size={"small"} onClick={() => demoteItem(item)}>Togli admin</Button>
                                      : 
                                        <Button size={"small"} variant={"default-o"} onClick={() => promoteItem(item)}>Rendi admin</Button>
                                      }                                      
                                      <Button size={"small"} onClick={() => deleteItem(item)}>Elimina</Button>
                                    </TableActions>
                                  ],
                                  link: ({children}) => (<Link to={"/admin/users/"+item.id}>{children}</Link>)
                                }))
                              }
                            />
                          </TableWrapper>
                        </>
                      : <NoResult>There are no results.</NoResult>
                    : <Loading bgcolor={"#ffffff"} />}
                  </Col>
                </Row>
                {/* {totPages > 1 ?
                  <OzPagination totPages={totPages} currentPage={page} onChange={((val) => setPage(val))} />
                : null } */}
              </Card>
            </Col>
          </Row>


          {showModalNew ? (
          <Overlay>
            <UsersNew
              fnSuccess={(uuid) => {
                navigate("/users/"+uuid);
                // getList();
                // toggleModalNew(false);
              }}
              fnCancel={() => toggleModalNew(false)}
            />
          </Overlay>
        ) : null}
          
        </Container>
      </div>
    </Layout>
  )
}

export default UsersList;
